import React from "react";
import PopUpComponent from "../../components/PopUp/PopUpComponent";
import "./ApprovalLaporan.css";
import { useApprovalLaporan } from "./useApprovalLaporan";
import RefreshIcon from "../../Assets/refresh-icon.png";
import moment from "moment";

const ApprovalLaporan = () => {
  const {
    dataUser,
    shiftApprovalLaporan,
    setShiftApprovalLaporan,
    handleKirim,
    popUpApprovalLaporan,
    setPopUpApprovalLaporan,
    setDateApprovalLaporan,
    dateApprovalLaporan,
    listTopPlate,
    listPasangKaret,
    filterMesin,
    setFilterMesin,
    dataTempMesinInjeksi,
    filterMesinSelect,
    setIsRefresh,
    listPasangStiker,
  } = useApprovalLaporan();

  const sortData =
    dataTempMesinInjeksi &&
    dataTempMesinInjeksi.sort(function (a, b) {
      if (Number(a.mesin) < Number(b.mesin)) {
        return -1;
      }
      if (Number(a.mesin) > Number(b.mesin)) {
        return 1;
      }
      return 0;
    });

  const sortDataMesin =
    filterMesinSelect &&
    filterMesinSelect.sort(function (a, b) {
      if (Number(a.mesin) < Number(b.mesin)) {
        return -1;
      }
      if (Number(a.mesin) > Number(b.mesin)) {
        return 1;
      }
      return 0;
    });

  const sortDataPasangKaret =
    listPasangKaret &&
    listPasangKaret.sort(function (a, b) {
      if (Number(a.mesin) < Number(b.mesin)) {
        return -1;
      }
      if (Number(a.mesin) > Number(b.mesin)) {
        return 1;
      }
      return 0;
    });

  const sortDataPasangStiker =
    listPasangStiker &&
    listPasangStiker.sort(function (a, b) {
      if (Number(a.mesin) < Number(b.mesin)) {
        return -1;
      }
      if (Number(a.mesin) > Number(b.mesin)) {
        return 1;
      }
      return 0;
    });

  const handleOk = () => {
    setPopUpApprovalLaporan(false);
    window.location.reload();
  };

  return (
    <div className="container_dashboard apl-page">
      {popUpApprovalLaporan ? (
        <PopUpComponent>
          <p>Data Laporan Sudah Dikirim!</p>
          <div className="apl-popup-actions">
            <button className="apl-popup-btn" onClick={() => handleOk()}>
              OK
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      <p className="apl-section-title">Approval Laporan Produksi</p>
      <div className="apl-filter">
        <div className="apl-field">
          <p>Pilih Shift</p>
          <select
            className="apl-select"
            value={shiftApprovalLaporan}
            onChange={(e) => setShiftApprovalLaporan(e.target.value)}
          >
            <option selected={shiftApprovalLaporan === "Pilih Shift"} disabled>
              Pilih Shift
            </option>
            <option value="1">Shift 1</option>
            <option value="2">Shift 2</option>
            <option value="3">Shift 3</option>
          </select>
        </div>
        <div className="apl-field">
          <p>Pilih Tanggal</p>
          <input
            type="date"
            className="apl-date"
            value={dateApprovalLaporan}
            onChange={(e) => setDateApprovalLaporan(e.target.value)}
          />
        </div>
        <div style={{ marginBottom: "12px", marginRight: "12px" }}>
          <p>Pilih Mesin</p>
          <select
            className="apl-select"
            value={filterMesin}
            onChange={(e) => setFilterMesin(e.target.value)}
          >
            <option selected={filterMesin === "Pilih Mesin"} disabled>
              Pilih Mesin
            </option>
            {sortDataMesin &&
              sortDataMesin.map((obj) => <option value={obj}>{obj}</option>)}
          </select>
        </div>
        <div
          className="apl-field"
          style={{ display: "flex", alignItems: "end" }}
        >
          <p
            className="apl-btn-reset"
            style={{ marginBottom: "24px" }}
            onClick={() => setFilterMesin("Pilih Mesin")}
          >
            Reset
          </p>
          <img
            src={RefreshIcon}
            alt="refresh"
            style={{
              width: "36px",
              margin: "12px 0 24px 12px",
              cursor: "pointer",
            }}
            onClick={() => {
              setIsRefresh(true);
            }}
          />
        </div>
      </div>

      <div
        className="apl-card-grid"
        style={{
          marginTop: "18px",
        }}
      >
        {sortData &&
          sortData.map((data) => {
            const downtime = data.downtime ? data.downtime : 0;
            const dataCounterAwal = data.counterAwal ? data.counterAwal : 0;
            const dataCounterAkhir = data.counterAkhir ? data.counterAkhir : 0;

            const formula =
              (8 * 3600 - downtime * 60) / (dataCounterAkhir - dataCounterAwal);

            const indicatorCavity =
              data.jumlahBarang + data.jumlahNG ===
              (data.counterAkhir - data.counterAwal) * data.aktualCavity;
            return (
              <div className="apl-card">
                <div
                  className="apl-card-row"
                  style={{
                    margin: "12px 0 6px 0",
                  }}
                >
                  <p style={{ fontSize: "10px", margin: 0 }}>
                    {dataUser.tim === 1
                      ? "Form-PROD-A28-R2"
                      : "Form-PROD-A28-R8"}
                  </p>
                  <p style={{ fontSize: "10px", margin: 0 }}>
                    {moment(data.dateSubmit).format("HH:mm:ss")}
                  </p>
                </div>
                <div className="apl-card-row">
                  <p className="apl-machine" style={{ margin: "0 0 6px 0" }}>
                    Mesin&nbsp;{data.mesin}
                  </p>
                  <p style={{ margin: "0 0 6px 0" }}>
                    {moment(data.date).format("DD MMM YYYY")}
                  </p>
                  <p className="apl-bold" style={{ margin: "0 0 6px 0" }}>
                    {data.customer}
                  </p>
                </div>
                <div className="apl-row">
                  <p style={{ margin: "6px 0" }}>{data.operator}</p>
                </div>
                <div className="apl-row">
                  <p
                    className="apl-bold"
                    style={{ margin: "6px 0", fontWeight: "bold" }}
                  >
                    {data.moldType}
                  </p>
                </div>
                <div className="apl-row">
                  <p style={{ margin: "6px 0" }}>{data.color}</p>
                  <p style={{ textAlign: "end", margin: "6px 0" }}>
                    Shift&nbsp;{data.shift}
                  </p>
                </div>
                <div className="apl-row">
                  <div style={{ width: "50%" }}>
                    <p className="apl-bold" style={{ margin: "6px 0" }}>
                      Isi Per Kemasan
                    </p>
                    <p className="apl-value" style={{ margin: "6px 0" }}>
                      {data.isiPerKemasan}&nbsp;Pcs
                    </p>
                  </div>
                  <div style={{ width: "40%" }}>
                    <p className="apl-bold" style={{ margin: "6px 0" }}>
                      Aktual Cavity
                    </p>
                    <p className="apl-value" style={{ margin: "6px 0" }}>
                      {data.aktualCavity}
                    </p>
                  </div>
                </div>

                <div className="apl-row">
                  <div style={{ width: "50%" }}>
                    <p className="apl-bold" style={{ margin: "6px 0" }}>
                      Counter Akhir
                    </p>
                    <p className="apl-value" style={{ margin: "6px 0" }}>
                      {data.counterAkhir}
                    </p>
                  </div>
                  <div style={{ width: "40%" }}>
                    <p className="apl-bold" style={{ margin: "6px 0" }}>
                      Counter Awal
                    </p>
                    <p className="apl-value" style={{ margin: "6px 0" }}>
                      {data.counterAwal}
                    </p>
                  </div>
                </div>

                <div className="apl-row">
                  <div style={{ width: "50%" }}>
                    <p className="apl-bold" style={{ margin: "6px 0" }}>
                      Jumlah "NG"
                    </p>
                    <p className="apl-value" style={{ margin: "6px 0" }}>
                      {data.jumlahNG}&nbsp;Pcs
                    </p>
                  </div>
                  <div style={{ width: "40%" }}>
                    <p className="apl-bold" style={{ margin: "6px 0" }}>
                      Selisih Counter
                    </p>
                    <p className="apl-value" style={{ margin: "6px 0" }}>
                      {data.counterAkhir - data.counterAwal}&nbsp;Pcs
                    </p>
                  </div>
                </div>
                <div className="apl-row">
                  <div style={{ width: "50%" }}>
                    <p className="apl-bold" style={{ margin: "6px 0" }}>
                      Barang OK
                    </p>
                    <p className="apl-value" style={{ margin: "6px 0" }}>
                      {data.jumlahBarang}&nbsp;Pcs
                    </p>
                  </div>
                  <div style={{ width: "40%" }}>
                    <p className="apl-bold" style={{ margin: "6px 0" }}>
                      Down Time
                    </p>
                    <p className="apl-value" style={{ margin: "6px 0" }}>
                      {downtime}&nbsp;Menit
                    </p>
                  </div>
                </div>
                <div className="apl-row">
                  <div style={{ width: "50%" }}>
                    <p className="apl-bold" style={{ margin: "6px 0" }}>
                      Cycle Time
                    </p>
                    <p className="apl-value" style={{ margin: "6px 0" }}>
                      {formula === Infinity ? 0 : formula.toFixed(1)}&nbsp;Detik
                    </p>
                  </div>
                  <div style={{ width: "40%" }}>
                    <p className="apl-bold" style={{ margin: "6px 0" }}>
                      {dataUser.tim === 2
                        ? "Sisa Shift Sebelumnya"
                        : `Receh Shift ${data.shift}`}
                    </p>
                    <p className="apl-value" style={{ margin: "6px 0" }}>
                      {data.sisaShiftSebelumnya ? data.sisaShiftSebelumnya : 0}
                      &nbsp;Pcs
                    </p>
                  </div>
                </div>
                {dataUser.tim === 2 ? (
                  <div className="apl-row">
                    <div style={{ minWidth: "148px" }}>
                      <p>Produk OK + SISA</p>
                      <p>
                        {Number(data.jumlahBarang) +
                        Number(data.sisaShiftSebelumnya)
                          ? Number(data.jumlahBarang) +
                            Number(data.sisaShiftSebelumnya)
                          : 0}
                      </p>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {dataUser.tim === 2 ? (
                  <>
                    <div
                      style={
                        !indicatorCavity
                          ? { width: "40%", color: "red" }
                          : { width: "40%" }
                      }
                    >
                      <p
                        className="apl-bold"
                        style={{ fontWeight: "bold", margin: "6px 0" }}
                      >
                        Indikator Laporan
                      </p>
                      <p className="apl-value" style={{ margin: "6px 0" }}>
                        {!indicatorCavity ? "SALAH" : ""}
                      </p>
                    </div>
                  </>
                ) : (
                  ""
                )}
                <div className="apl-row">
                  <div style={{ width: "50%" }}>
                    <p
                      className="apl-bold"
                      style={{ margin: "6px 0", fontWeight: "bold" }}
                    >
                      Aktual Barang
                    </p>
                    <p className="apl-value" style={{ margin: "12px 0 6px 0" }}>
                      {data.aktualBarang}&nbsp;Pcs
                    </p>
                  </div>
                  {dataUser.tim === 2 ? (
                    <div style={{ width: "40%" }}>
                      <p style={{ margin: "6px 0", fontWeight: "bold" }}>
                        Selisih Barang
                      </p>
                      <p style={{ margin: "12px 0 6px 0" }}>
                        {data.aktualBarang
                          ? Number(data.aktualBarang) -
                            Number(data.jumlahBarang) -
                            Number(data.sisaShiftSebelumnya)
                          : 0}
                        &nbsp;Pcs
                      </p>
                    </div>
                  ) : (
                    ""
                  )}
                </div>

                <div>
                  <div className="apl-row">
                    <p
                      style={{
                        width: "50%",
                        fontWeight: "bold",
                        margin: "6px 0",
                      }}
                    >
                      Perincian "NG"
                    </p>
                    <p
                      style={{
                        width: "40%",
                        fontWeight: "bold",
                        margin: "6px 0",
                      }}
                    >
                      Jumlah
                    </p>
                  </div>
                  {data.perincianNG &&
                    data.perincianNG.map((perincian) => {
                      return (
                        <div className="apl-row">
                          <p
                            style={{
                              fontSize: "14px",
                              width: "50%",
                              margin: "6px 0",
                            }}
                          >
                            {perincian.id}
                          </p>
                          <p
                            style={{
                              fontSize: "14px",
                              width: "40%",
                              margin: "6px 0",
                            }}
                          >
                            {perincian.totalNG}&nbsp;Pcs
                          </p>
                        </div>
                      );
                    })}
                  <div>
                    <p className="apl-bold" style={{ margin: "12px 0 6px 0" }}>
                      Keterangan
                    </p>
                    {data.keterangan !== "" || dataUser.tim === 2 ? (
                      <p style={{ wordWrap: "break-word" }}>
                        {data.keterangan}
                      </p>
                    ) : (
                      <>
                        <div
                          style={{
                            width: "100%",
                          }}
                        >
                          <table
                            style={{
                              width: "100%",
                            }}
                          >
                            <tr>
                              <th
                                style={{
                                  padding: "8px 0px 8px 12px",
                                  textAlign: "left",
                                  fontSize: "12px",
                                  position: "static",
                                }}
                              >
                                Jam
                              </th>
                              <th
                                style={{
                                  padding: "8px 0px 8px 12px",
                                  textAlign: "left",
                                  fontSize: "12px",
                                  position: "static",
                                }}
                              >
                                Keterangan
                              </th>
                            </tr>

                            {data.dataKeterangan.map((ele) => {
                              return (
                                <tr>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      paddingLeft: "10px",
                                      paddingTop: "8px",
                                      whiteSpace: "nowrap",
                                      fontSize: "12px",
                                    }}
                                  >
                                    {ele.jam}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      paddingLeft: "10px",
                                      paddingTop: "8px",
                                      wordBreak: "break-all",
                                      fontSize: "12px",
                                    }}
                                  >
                                    {ele.keterangan}
                                  </td>
                                </tr>
                              );
                            })}
                          </table>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
      </div>
      {listPasangKaret && listPasangKaret.length > 0 ? (
        <p className="apl-section-title">Laporan Pasang Karet</p>
      ) : (
        ""
      )}
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {sortDataPasangKaret &&
          sortDataPasangKaret.map((obj) => {
            const downtimePasangKaret = obj.downtime ? obj.downtime : 0;
            const jumlahPasangKaret = obj.jumlah ? obj.jumlah : 0;
            const aktualCavityPasangKaret = obj.aktualCavity
              ? obj.aktualCavity
              : 0;
            const formula =
              (28800 - downtimePasangKaret * 60) / jumlahPasangKaret;

            return (
              <div className="apl-card-simple">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <p className="apl-machine" style={{ width: "25%" }}>
                    Mesin {obj.mesin}
                  </p>
                  <p style={{ fontWeight: "bold" }}>{obj.operator}</p>
                </div>
                <p style={{ fontWeight: "bold" }}>
                  {obj.produk} - {obj.warna}
                </p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div style={{ width: "50%" }}>
                    <p style={{ fontWeight: "bold" }}>Target Produksi</p>
                    <p
                      style={
                        Math.floor(
                          ((28800 - obj.downtime * 60) / 43.2) *
                            aktualCavityPasangKaret
                        ) > jumlahPasangKaret
                          ? { color: "red" }
                          : {}
                      }
                    >
                      {(
                        ((28800 - obj.downtime * 60) / 43.2) *
                        aktualCavityPasangKaret
                      ).toFixed(0)}
                    </p>
                  </div>
                  <div style={{ width: "40%" }}>
                    <p style={{ fontWeight: "bold" }}>Cycle Time</p>
                    <p>
                      {(formula * aktualCavityPasangKaret).toFixed(1)} Detik
                    </p>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <p>
                      <b>Jumlah Pasang Karet</b>
                    </p>
                    <p>{obj.jumlah} Pcs</p>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div style={{ width: "50%" }}>
                    <p>
                      <b>Downtime</b>
                    </p>
                    <p>{obj.downtime} Menit</p>
                  </div>
                  <div style={{ width: "40%" }}>
                    <p>
                      <b>Aktual Cavity</b>
                    </p>
                    <p>{obj.aktualCavity ? obj.aktualCavity : ""}</p>
                  </div>
                </div>
                <p className="apl-bold">Keterangan</p>
                {obj.keterangan &&
                  obj.keterangan.split("\n").map((subStr) => {
                    return <p>{subStr}</p>;
                  })}
              </div>
            );
          })}
      </div>
      {listPasangStiker && listPasangStiker.length > 0 ? (
        <p className="apl-section-title">Laporan Pasang Sticker</p>
      ) : (
        ""
      )}
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {sortDataPasangStiker &&
          sortDataPasangStiker.map((obj) => {
            return (
              <div className="apl-card-simple">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <p
                    className="apl-machine"
                    style={{ width: "25%", margin: "12px 0 6px 0" }}
                  >
                    Mesin {obj.mesin}
                  </p>
                  <p style={{ fontWeight: "bold", margin: "12px 0 6px 0" }}>
                    {obj.operator}
                  </p>
                </div>
                <p style={{ fontWeight: "bold", margin: "6px 0" }}>
                  {obj.produk} - {obj.warna}
                </p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <div>
                    <p style={{ margin: "6px 0" }}>
                      <b>Jumlah Pasang</b>
                    </p>
                    <p style={{ margin: "6px 0" }}>{obj.jumlah} Pcs</p>
                  </div>
                  <div>
                    <p style={{ margin: "6px 0" }}>
                      <b>NG Sticker</b>
                    </p>
                    <p style={{ margin: "6px 0" }}>{obj && obj.reject} Pcs</p>
                  </div>
                  <div>
                    <p style={{ margin: "6px 0" }}>
                      <b>NG Produk</b>
                    </p>
                    <p style={{ margin: "6px 0" }}>
                      {obj && obj.rejectProduk} Pcs
                    </p>
                  </div>
                  <div>
                    <p style={{ margin: "6px 0" }}>
                      <b>Downtime</b>
                    </p>
                    <p style={{ margin: "6px 0" }}>{obj.downtime} Menit</p>
                  </div>
                  {obj?.kindOfReject?.length > 0 ? (
                    <div>
                      <p style={{ margin: "6px 0" }}>
                        <b>Ket. Reject Produk</b>
                      </p>
                      <table>
                        <tr>
                          <th style={{ position: "inherit" }}>Shift</th>
                          <th
                            style={{
                              position: "inherit",
                              textAlign: "left",
                              padding: "18px 0 18px 6px",
                            }}
                          >
                            Jenis Reject
                          </th>
                          <th
                            style={{
                              padding: "18px 6px",
                              position: "inherit",
                            }}
                          >
                            Reject
                          </th>
                        </tr>
                        {obj.kindOfReject &&
                          obj.kindOfReject.map((ele, index) => {
                            return (
                              <tr
                                style={
                                  index % 2 === 0
                                    ? {
                                        background: "white",
                                        fontSize: "12px",
                                      }
                                    : {
                                        background: "#f2f2f2",
                                        fontSize: "12px",
                                      }
                                }
                              >
                                <td style={{ padding: "12px 6px" }}>
                                  {ele.shift}
                                </td>
                                <td
                                  style={{
                                    padding: "12px 0 12px 6px",
                                    textAlign: "left",
                                  }}
                                >
                                  {ele.id}
                                </td>
                                <td style={{ padding: "12px 6px" }}>
                                  {ele.totalNG}
                                </td>
                              </tr>
                            );
                          })}
                      </table>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <p className="apl-bold" style={{ margin: "6px 0" }}>
                  Keterangan
                </p>
                {obj.keterangan &&
                  obj.keterangan.split("\n").map((subStr) => {
                    return <p>{subStr}</p>;
                  })}
              </div>
            );
          })}
      </div>

      {listTopPlate && listTopPlate.length > 0 ? (
        <p className="apl-section-title">Laporan Pasang Top Plate</p>
      ) : (
        ""
      )}
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {listTopPlate &&
          listTopPlate.map((obj) => {
            return (
              <div className="apl-card-simple">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <p
                    className="apl-machine"
                    style={{ width: "25%", margin: "12px 0 6px 0" }}
                  >
                    Mesin {obj.mesin}
                  </p>
                  <p style={{ fontWeight: "bold", margin: "12px 0 6px 0" }}>
                    {obj.operator}
                  </p>
                </div>
                <p style={{ fontWeight: "bold", margin: "6px 0" }}>
                  {obj.produk}
                </p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <p style={{ margin: "6px 0" }}>
                      <b>Jumlah Pasang</b>
                    </p>
                    <p style={{ margin: "6px 0" }}>{obj.jumlah} Pcs</p>
                  </div>
                  <div>
                    <p style={{ margin: "6px 0" }}>
                      <b>Downtime</b>
                    </p>
                    <p style={{ margin: "6px 0" }}>{obj.downtime} Menit</p>
                  </div>
                </div>
                <p className="apl-bold" style={{ margin: "6px 0" }}>
                  Keterangan
                </p>
                {obj.keterangan &&
                  obj.keterangan.split("\n").map((subStr) => {
                    return <p>{subStr}</p>;
                  })}
              </div>
            );
          })}
      </div>

      {(sortData && sortData.length > 0) ||
      (listPasangKaret && listPasangKaret.length > 0) ||
      (listPasangStiker && listPasangStiker.length > 0) ||
      (listTopPlate && listTopPlate.length > 0) ? (
        <button className="apl-submit" onClick={() => handleKirim()}>
          Kirim
        </button>
      ) : (
        ""
      )}
    </div>
  );
};
export default ApprovalLaporan;
